import { createSlice } from '@reduxjs/toolkit';

// The tree is stored exactly as the API nests it. Flattening here and re-nesting
// on render is where sibling ordering drifts.
const taxonomySlice = createSlice({
  name: 'taxonomy',
  initialState: {
    tree: [],
    version: null,
    attributes: [],
    selectedNodeId: null,
    loading: false,
    saving: false,
    error: null,
    attributesError: null,
  },
  reducers: {
    getTaxonomyTreeAction: (state) => {
      state.loading = true;
      state.error = null;
    },
    getTaxonomyTreeSuccess: (state, action) => {
      state.tree = action.payload?.nodes || [];
      state.version = action.payload?.version || null;
      state.loading = false;
      state.error = null;
    },
    getTaxonomyTreeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Attributes keep their own error: they load beside the audio form, which reads
    // `error` as "the save failed".
    getAttributeDefinitionsAction: (state) => {
      state.attributesError = null;
    },
    getAttributeDefinitionsSuccess: (state, action) => {
      const payload = action.payload;
      const definitions = payload?.data || payload?.results || payload || [];
      state.attributes = Array.isArray(definitions) ? definitions : [];
      state.attributesError = null;
    },
    getAttributeDefinitionsFailure: (state, action) => {
      state.attributesError = action.payload;
    },
    createTaxonomyNodeAction: (state) => {
      state.saving = true;
      state.error = null;
    },
    updateTaxonomyNodeAction: (state) => {
      state.saving = true;
      state.error = null;
    },
    deleteTaxonomyNodeAction: (state) => {
      state.saving = true;
      state.error = null;
    },
    reorderTaxonomyNodeAction: (state) => {
      state.saving = true;
      state.error = null;
    },
    moveTaxonomyNodeAction: (state) => {
      state.saving = true;
      state.error = null;
    },
    taxonomyMutationSuccess: (state, action) => {
      state.saving = false;
      state.error = null;
      if (action.payload?.selectId) state.selectedNodeId = action.payload.selectId;
    },
    taxonomyMutationFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },
    /** Merge a server-returned node into the tree in place - no full refetch. */
    taxonomyNodePatched: (state, action) => {
      const patch = action.payload;
      if (!patch?.id) return;
      const walk = (nodes) =>
        (nodes || []).some((node) => {
          if (node.id === patch.id) {
            Object.assign(node, patch, { children: node.children });
            return true;
          }
          return walk(node.children);
        });
      walk(state.tree);
    },
    selectTaxonomyNode: (state, action) => {
      state.selectedNodeId = action.payload;
    },
  },
});

export const {
  selectTaxonomyNode,
  taxonomyNodePatched,
  getTaxonomyTreeAction,
  getTaxonomyTreeSuccess,
  getTaxonomyTreeFailure,
  taxonomyMutationSuccess,
  taxonomyMutationFailure,
  moveTaxonomyNodeAction,
  createTaxonomyNodeAction,
  updateTaxonomyNodeAction,
  deleteTaxonomyNodeAction,
  reorderTaxonomyNodeAction,
  getAttributeDefinitionsAction,
  getAttributeDefinitionsSuccess,
  getAttributeDefinitionsFailure,
} = taxonomySlice.actions;

export { taxonomySlice };
